export default "__VITE_ASSET__BmpwJjtI__"